import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import { termsOfServiceData } from '../Common/TermsOfServiceData';
import FeedbackPopup from '../Common/FeedbackPopup';
import { useState } from 'react';
import FooterComponent from '../Common/FooterComponent';

function TermsofService(){

    const [showFeedbackPopup, setShowFeedbackPopup] = useState(false);

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 
    
    const termsOfServiceEle = termsOfServiceData.map((ele, idx) => {
        return(
            <div className='tosEle' key={idx}>
                <div className='tosHeader'>{ele.header}</div>
                <div className='tosContent'>{ele.content}</div>
            </div>
        )
    });

    return(
        <div className='parentDiv'>
            <div className='mainDiv termsOfService'>
                <div className='header'>
                    <Navbar />
                </div>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>Terms & Conditions</div>
                        <div className='contentBox'>
                            <div className='content'>
                                {termsOfServiceEle}
                            </div>
                        </div>
                    </div>
                </div>
                {showFeedbackPopup && <FeedbackPopup closeFeedbackPopup={() => setShowFeedbackPopup(false)}/>}
            </div>
            <FooterComponent setShowFeedbackPopup={setShowFeedbackPopup}/>
        </div>
    )
}

export default TermsofService;